// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.flex-container[data-v-12fc92f3] {\n  display: flex;\n  align-items: center;\n}\n.flex-container > *[data-v-12fc92f3] {\n  flex-grow: 1;\n  flex-basis: 0;\n  margin: 0;\n}\n.quantity-block[data-v-12fc92f3] {\n  flex-grow: 1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
